"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = HomePage;
var React = require("react");
var state_1 = require("./state");
var Actions_1 = require("./Actions");
var ProductsList_1 = require("./ProductsList");
var ComparePreview_1 = require("./ComparePreview");
function HomePage() {
    var _a = (0, state_1.useStateValue)(), state = _a.state, dispatch = _a.dispatch;
    var props = {
        products: state.products,
        episodes: state.episodes,
        state: { state: state, dispatch: dispatch },
        toggleFavAction: Actions_1.toggleFavAction,
        resetAction: Actions_1.resetAction,
        favourites: state.favourites
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "episode-layout" },
            React.createElement(ProductsList_1.default, __assign({}, props)),
            React.createElement(ComparePreview_1.default, __assign({}, props)))));
}
